module.exports = __webpack_public_path__ + "static/media/btn-recargas.a5049572.png";